module.exports = __webpack_public_path__ + "img/snow-4.b066168a.svg";